<template>
  <v-col>
    <v-row cols="12">
      <v-col
        cols="12"
        md="3"
      >
        <v-list
          nav
          dense
        >
          <v-list-item
            v-for="item in items"
            :key="item.title"
            link
            :to="item.action"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <p class="updatedAt">
          Last update: {{ main.updated_at }}
        </p>
        <router-view />
      </v-col>
    </v-row>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            items: [
                {
                    action: "/settings/general",
                    icon: "mdi-home",
                    title: "General",
                },
                {
                    action: "/settings/mail",
                    icon: "mdi-email-lock",
                    title: "Mail SMTP",
                },
                {
                    action: "/settings/logo",
                    icon: "mdi-tooltip-image-outline",
                    title: "Logos",
                },
                {
                    action: "/settings/terms-and-conditions",
                    icon: "mdi-certificate",
                    title: "T&C",
                },
                {
                    action: "/settings/pos-configs",
                    icon: "mdi-rhombus-outline",
                    title: "POS",
                },
                {
                    action: "/settings/billing",
                    icon: "mdi-note-text",
                    title: "Bill",
                },
                {
                    action: "/settings/units",
                    icon: "mdi-weight-kilogram",
                    title: "Units",
                },
                {
                    action: "/settings/announcement",
                    icon: "mdi-decagram",
                    title: "Announcement",
                },
            ],
        };
    },
    created() {
        Event.$on("bootConfigs", (data, msg) => {
            this.configsUpdate(data);
            this.feedback(msg);
        });

        Event.$on("updateConfigs", (data) => {
            window.axios
                .post(`/${data.path}`, data.payload)
                .then((response) => {
                    Event.$emit(
                        "bootConfigs",
                        response.data.updated,
                        response.data.message
                    );
                    setTimeout(() => {
                        window.location.reload();
                    }, 1500);
                });
        });
    },
    computed: {
        ...mapGetters({
            main: "configs/overall",
        }),
    },
    methods: {
        ...mapActions({
            configsUpdate: "configs/boot",
            feedback: "snackbar/show",
        }),
    },
};
</script>

<style type="text/css">
.v-tab {
    justify-content: left;
}
.updatedAt {
    font-size: 9px;
    color: red;
}
</style>
